import { useState } from "react";
import { faqItems } from "@/mocks/rankingData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex justify-center">
          {/* FAQ */}
          <div className="w-full max-w-3xl">
            <span className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-2 block">
              FAQ
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
              よくある質問
            </h2>

            <div className="space-y-3">
              {faqItems.map((item, i) => (
                <div
                  key={i}
                  className="border border-gray-200 rounded-xl overflow-hidden"
                >
                  <button
                    className="whitespace-nowrap w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-brand-50/50 transition-colors"
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  >
                    <div className="flex items-start gap-3">
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-brand-500 text-white text-xs font-bold mt-0.5">
                        Q
                      </span>
                      <span className="font-semibold text-gray-900 text-sm whitespace-normal">{item.q}</span>
                    </div>
                    <i
                      className={`ri-${openIndex === i ? "subtract" : "add"}-line text-gray-400 flex-shrink-0 transition-transform`}
                    />
                  </button>

                  {openIndex === i && (
                    <div className="px-5 pb-5 pt-1 border-t border-gray-100">
                      <div className="flex items-start gap-3">
                        <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-bold mt-0.5">
                          A
                        </span>
                        <p className="text-gray-700 text-sm leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}